import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(networks)/(evm)/[chainId]/(trade)/error.tsx");
